/****************************************************
 * Module Name:  addSaleModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import {
  Box, Button, FormControlLabel, Radio, RadioGroup, FormControl, TextField, Typography, FormLabel, Pagination,
  Stack, InputAdornment, FormGroup, styled, Switch, Tooltip, Autocomplete, MenuItem, Select as MuiSelect
} from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import Select from "react-select";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "../../style/modalstyle.css";
import { useEffect } from "react";
import TradingcompanyProxy from "../../utility/proxy/manager/tradingcompanyProxy";
import Utility from "../../utility/utility";
import { FaFileInvoiceDollar, FaFileInvoice } from "react-icons/fa";
import { LoadingButton } from "@mui/lab";
import ExportComponent from "../common/exportComponent";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import BrokerProxy from "../../utility/proxy/manager/brokerProxy";
import logo from '../../images/pansuriya.jpg'
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import BucketDetailModal from "../mixDiamondSales/bucketDetailModal";
import UtilityProxy from "../../utility/proxy/manager/utilityProxy";
import UserProfileProxy from "../../utility/proxy/manager/userProfileProxy";
import UserProxy from "../../utility/proxy/manager/userProxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  '& .MuiDataGrid-columnHeader': {
    color: '#fff',
    fontSize: Constants.defaultTableFontSize,
    fontWeight: Constants.defaultFontWeight,
    backgroundColor: 'grey',
  },
  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
    py: "8px",
    fontSize: Constants.defaultTableFontSize,
    fontWeight: Constants.defaultFontWeight,
  },
  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
    py: "15px",
    fontSize: Constants.defaultTableFontSize,
    fontWeight: Constants.defaultFontWeight,
  },
  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
    py: "22px",
    fontSize: Constants.defaultTableFontSize,
    fontWeight: Constants.defaultFontWeight,
  },
}));

const typeOptions = [
  { value: "local", label: "Local" },
  { value: "export", label: "Export" },
];

const discountCalculator = (actualPrice, discount) =>
  Number(actualPrice * ((100 + Number(discount)) / 100)).toFixed(2);

let exportData = {};

let exportComponentData = (data) => {
  exportData = data;
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#2E7D32',
      },
    },
    '&.Mui-disabled': { // Handle disabled state
      color: '#B0B0B0', // Light grey thumb
      '& + .MuiSwitch-track': {
        backgroundColor: '#A0A0A0', // Darker grey for track
        opacity: 0.7,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    willChange: 'transform',
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 0,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const getDropdownEditComponent = (options, listData, openDropdown, setOpenDropdown, setRows) => {

  return function DropdownEditComponent(params) {

    const value = options.find(opt => opt.label === params.value) || null;

    const handleChange = (e, selectedOption) => {
      // Find the associated data from listData
      let data = listData.find((data) => data.id === selectedOption.value);

      // using updateRows for the non editable fields
      // and seteditCellValue for the editable fields to set the values
      const updatedData = {
        ...params.row,
        bucketid: selectedOption.value,
        bucket: selectedOption.label,
        qty: data.qty || 0,
        avgprice: data.avgprice || 0,
        purchaseprice: data.defaultsellprice || 0,
      };

      let id = params.id;
      params.api.updateRows([{ id, ...updatedData }]);
      params.api.setEditCellValue({ id: params.id, field: params.field, value: selectedOption.label }, e);
      params.api.stopCellEditMode({ id: params.id, field: params.field });

      // Update the rows with new data
      setRows(oldRows => oldRows.map(row => row.id === params.id ? {
        ...row,
        ...updatedData
      } : row));

      setOpenDropdown(false);
    }

    // Custom filter for "contains in any order"
    const customFilterOptions = (options, { inputValue }) => {
      if (!inputValue) return options; // Show all if no input

      const searchWords = inputValue.toLowerCase().split(" ").filter(Boolean);

      return options.filter(option => {
        const labelWords = option.label.toLowerCase().split(" ");
        return searchWords.every(word =>
          labelWords.some(labelWord => labelWord.includes(word))
        );
      });
    };

    return (
      <Autocomplete
        autoFocus
        fullWidth
        disableClearable
        disableCloseOnSelect
        openOnFocus
        options={options}
        filterOptions={customFilterOptions}
        value={value}
        open={openDropdown}
        onOpen={() => setOpenDropdown(true)}
        onClose={() => setOpenDropdown(false)}
        onChange={(e, selectedOption) => handleChange(e, selectedOption)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.label || ''}
        renderInput={(inputParams) => (
          <TextField
            {...inputParams}
            variant="standard"
            size="small"
            InputProps={{
              ...inputParams.InputProps,
              style: {
                minHeight: 36,
                maxHeight: 36,
                overflow: 'hidden',
                alignItems: 'center',
                fontSize: '0.80rem'
              }
            }}
          />
        )}
        ListboxProps={{
          style: {
            maxHeight: 200,
            overflowY: 'auto',
            fontSize: '0.80rem'
          },
        }}
      />
    );
  };
};

const AddSaleModal = ({
  show,
  setShow,
  handleValidation,
  handleInvoice,
  handleProforma,
  user,
  memoId,
  proformaButton,
  sourceData,
  customer,
  stockData,
  loading,
  loadingProformaButton,
  notPermitted,
  bucketData,
  bucketDisabled
}) => {
  const { apiRef, handleCellClick } = Utility.useSingleClickEdit();
  const [company, setCompany] = useState();
  const [companyOptions, setCompanyOptions] = useState();
  const [date, setDate] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [type, setType] = useState(typeOptions[0]);
  const [countryOfOrigin, setCountryOfOrigin] = useState("");
  const [insurredBy, setInsurredBy] = useState("");
  const [portOfLoading, setPortOfLoading] = useState("");
  const [countryOfFinalDestination, setCountryOfFinalDestination] = useState("");
  const [shippedBy, setShippedBy] = useState("");
  const [portOfDischarge, setPortOfDischarge] = useState("");
  const [terms, setTerms] = useState("");
  const [finalDestination, setFinalDestination] = useState("");
  const [bankThrough, setBankThrough] = useState(false);
  const [listData, setListData] = useState([]);
  const [totalCarat, setTotalCarat] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [exchangeRate, setExchangeRate] = useState(1);
  const [currency, setCurrency] = useState("USD");
  const [lUser, setLUser] = useState(user);
  const [actualAmount, setActualAmount] = useState(0);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [remark, setRemark] = useState("");
  const [page, setPage] = useState(1);
  const [proformaPaginatedValueId, setProformaPaginatedValueId] = useState([]);
  const [bucket, setBucket] = useState([]);
  const [bucketOption, setBucketOption] = useState([]);
  const [disableAllButtons, setDisableAllButtons] = useState(false);
  const [disableSell, setDisableSell] = useState(proformaButton);
  const [newInvoiceAmount, setNewInvoiceAmount] = useState(0);

  const [qtyPermission, setQtyPermission] = useState(false);
  const [avgPricePermission, setAvgPricePermission] = useState(false);
  const [invoiceDays, setInvoiceDays] = useState(0);

  const [showBucketDetailModal, setShowBucketDetailModal] = useState(false);
  const [bucketId, setBucketId] = useState([]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarVariant, setSnackbarVariant] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [customerStatePresent, setCustomerStatePresent] = useState(false);
  const [customerState, setCustomerState] = useState("");
  const [tradingCompanyState, setTradingCompanyState] = useState("");

  const [CGSTPercent, setCGSTPercent] = useState(0.00);
  const [SGSTPercent, setSGSTPercent] = useState(0.00);
  const [IGSTPercent, setIGSTPercent] = useState(0.00);

  const [CGSTValue, setCGSTValue] = useState(0);
  const [SGSTValue, setSGSTValue] = useState(0);
  const [IGSTValue, setIGSTValue] = useState(0);

  const [addGst, setAddGst] = useState(!(currency === "USD"));

  const proforma_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.MIX_SALES_PROFORMA);

  const invoice_Permission = Constants.USER_PERMISSION.filter((iPermission) =>
    iPermission.permissionid === Constants.PERMISSIONS.DIRECTMIXINVOICE);

  const [rows, setRows] = React.useState([]);
  const [brokerData, setBrokerData] = useState({
    broker: { value: -1, label: " - " },
    brokerOptions: [],
  });
  const [customerData, setCustomerData] = useState({
    customer: customer || "",
    customerOptions: [],
  });
  const [flag, setFlag] = useState(false);
  const [showUserDetailModal, setShowUserDetailModal] = useState(false);
  const [userDetailContext, setUserDetailContext] = useState("");
  const [openDropdown, setOpenDropdown] = useState(true);
  const [applyValue, setApplyValue] = useState();
  const [applyToAll, setApplyToAll] = useState("discount1");

  useEffect(() => {
    getAllBucketData();
    getAllSettingValues();
    if (!sourceData)
      prepareUserData();

    Constants.USER_COLUMN_PERMISSION.forEach(iColumnPermission => {
      if (iColumnPermission === "03c60e42-31d0-4b12-b8f0-d7e141ae6c28") {
        setQtyPermission(true);
      }
      if (iColumnPermission === "809a4ec3-4c31-4077-b96d-97d53d57efac") {
        setAvgPricePermission(true);
      }
    })
  }, []);

  const getAllSettingValues = () => {
    let settingKeys = [];
    settingKeys.push("MIX_CGST");
    settingKeys.push("MIX_SGST");
    settingKeys.push("MIX_IGST");

    if (proformaButton)
      settingKeys.push("MIX_DEFAULT_INVOICE_DAYS");

    SettingsProxy.GetSettingsByName(settingKeys, (response) => {
      if (response) {
        response.forEach(iSetting => {
          if (iSetting.settingkey === "MIX_CGST") {
            setCGSTPercent(iSetting.settingvalue);
          }
          else if (iSetting.settingkey === "MIX_SGST") {
            setSGSTPercent(iSetting.settingvalue);
          }
          else if (iSetting.settingkey === "MIX_IGST") {
            setIGSTPercent(iSetting.settingvalue);
          }
          else if (iSetting.settingkey === "MIX_DEFAULT_INVOICE_DAYS") {
            setInvoiceDays(iSetting.settingvalue);
          }
        })
      }
    });
  }

  const getAllBucketData = () => {
    MixBucketProxy.GetAllBucketDetailMini((response) => {
      setAllBucketData(response);
    });
  };

  const setAllBucketData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label:
          data.stonetypefullname +
          " | " +
          data.shape +
          " | " +
          data.size +
          " | " +
          data.color +
          " | " +
          data.clarity,
      };
      optionsArray.push(option);
      return true;
    });
    setBucketOption(optionsArray);
    setBucket(bucket.length !== 0 && optionsArray.length > 0 ? optionsArray[0] : bucket);
    setListData(response);
  };

  const getEmployeeCustomers = () => {
    UserProxy.GetSpecificEmployeesCustomerMini(Constants.loggedInUser.id, (response) => {
      setEmployeeCustomers(response)
    });
  };

  const prepareUserData = () => {
    if (Constants.loggedInUser.usertype === "C") {
      setFlag(true);
      getCustomerBrokers(Constants.loggedInUser.id);
    } else if (Constants.loggedInUser.usertype === "E") {
      getEmployeeCustomers();
    }
    return true;
  };

  const setEmployeeCustomers = (response) => {
    let customerOptionsArray = [];
    response.forEach((data) => customerOptionsArray.push({ value: data.id, label: data.companyname }));
    setCustomerData({
      customerOptions: customerOptionsArray,
      customer: customerData.customer === "" && customerOptionsArray.length > 0 ? "" : customerData.customer,
    });
    setFlag(true);
  };

  const prepareProformaDetailData = (response) => {
    setType(
      response !== null && response !== undefined && response.export !== null
        ? response.export
          ? typeOptions[1]
          : typeOptions[0]
        : { value: "error", label: "error" }
    );
    setCountryOfOrigin(
      response !== null &&
        response !== undefined &&
        response.countryoforigin !== null
        ? response.countryoforigin
        : ""
    );
    setInsurredBy(
      response !== null && response !== undefined && response.ensuredby !== null
        ? response.ensuredby
        : ""
    );
    setPortOfLoading(
      response !== null &&
        response !== undefined &&
        response.portofloading !== null
        ? response.portofloading
        : ""
    );
    setCountryOfFinalDestination(
      response !== null &&
        response !== undefined &&
        response.countryoffinaldestination !== null
        ? response.countryoffinaldestination
        : ""
    );
    setShippedBy(
      response !== null && response !== undefined && response.shippedby !== null
        ? response.shippedby
        : ""
    );
    setPortOfDischarge(
      response !== null &&
        response !== undefined &&
        response.portofdischarge !== null
        ? response.portofdischarge
        : ""
    );
    setTerms(
      response !== null && response !== undefined && response.terms !== null
        ? response.terms
        : ""
    );
    setFinalDestination(
      response !== null &&
        response !== undefined &&
        response.finaldestination !== null
        ? response.finaldestination
        : ""
    );
    setBankThrough(
      response !== null &&
        response !== undefined &&
        response.bankthrough !== null
        ? response.bankthrough
        : ""
    );
    setRemark(
      response !== null && response !== undefined && response.remarks !== null
        ? response.remarks
        : ""
    );
    setCompany(
      response !== null &&
        response !== undefined &&
        response.tradingcompanyid !== null &&
        response.tradingcompanyname !== null
        ? {
          value: response.tradingcompanyid,
          label: response.tradingcompanyname,
        }
        : { value: "error", label: "error" }
    );
    setShippingCost(
      response !== null &&
        response !== undefined &&
        response.shippingcost !== null
        ? response.shippingcost
        : ""
    );
    setExchangeRate(
      response !== null &&
        response !== undefined &&
        response.exchangerate !== null
        ? response.exchangerate
        : 1
    );
    setCurrency(
      response !== null &&
        response !== undefined &&
        response.exchangecurrency !== null
        ? response.exchangecurrency
        : "INR"
    );
    setLUser(
      response !== null &&
        response !== undefined &&
        response.userid !== null &&
        response.username !== null
        ? response.userid + " | " + response.usercompanyname
        : ""
    );
    setInvoiceDays(
      response !== null &&
        response !== undefined &&
        response.days !== null
        ? response.days
        : 0
    );
    setCustomerData(
      response !== null &&
        response !== undefined &&
        response.customerid !== null &&
        response.customercompanyname !== null
        ? { ...customerData, customer: { value: response.customerid, label: response.customerid + " | " + response.customercompanyname } }
        : { ...customerData }
    );
    setBrokerData(
      response !== null &&
        response !== undefined &&
        response.brokerid !== null &&
        response.brokercompanyname !== null
        ? { ...brokerData, broker: { value: response.brokerid, label: response.brokerid + " | " + response.brokercompanyname } }
        : { ...brokerData }
    );
    getEmployeeCustomers();
  };

  useEffect(() => {
    if (sourceData) {
      prepareProformaDetailData(sourceData[0]);
      setProformaPaginatedValueId(sourceData[0].proformaid);
    }
    if (stockData) {
      let lTotalCarat = 0;
      let lActualPrice = 0;
      let newListData = [];
      let lInvoiceAmount = 0;
      let totalValueOfInrMulExchangeRate = 0;
      let totalValueOfInr = 0;
      let onlyUsd = true;
      let priceAfterDiscount1 = 0;
      let priceAfterDiscount2 = 0;
      let priceAfterDiscount3 = 0;
      stockData.map((res) => {
        if (res.exchangecurrency === "INR") {
          totalValueOfInrMulExchangeRate += Number(
            res.sellqty * res.price * Number(res.exchangerate)
          );
          totalValueOfInr += Number(res.sellqty * res.price);
          onlyUsd = false;
        }
        lTotalCarat += Number(res.sellqty);
        lActualPrice += Number(res.sellqty * res.price);
        priceAfterDiscount1 = discountCalculator(Number(res.sellqty * res.price), res.discount1);
        priceAfterDiscount2 = discountCalculator(priceAfterDiscount1, res.discount2);
        priceAfterDiscount3 = discountCalculator(priceAfterDiscount2, res.discount3);
        let listOp = {
          ...res,
          purchaseprice: res.price,
          purchaseqty: res.sellqty,
          bucket: res.stonetypefullname +
            " | " +
            res.shape +
            " | " +
            res.size +
            " | " +
            res.color +
            " | " +
            res.clarity,
          finalprice: priceAfterDiscount3,
        };
        newListData.push(listOp);
        lInvoiceAmount += Number(listOp.finalprice);
        return true;
      });
      setTotalDiscount(Number(100 - (lInvoiceAmount * 100) / lActualPrice).toFixed(2) * -1);
      setTotalCarat(lTotalCarat.toFixed(2));
      setActualAmount(lActualPrice.toFixed(2));
      setRows(newListData);
      setInvoiceAmount(lInvoiceAmount.toFixed(2));
      setNewInvoiceAmount(lInvoiceAmount.toFixed(2));
      if (!onlyUsd) {
        setExchangeRate((totalValueOfInrMulExchangeRate / totalValueOfInr).toFixed(2));
      }
    }

    if (bucketData) {
      let row = [{
        id: rows.length + 1,
        bucketid: bucketData.id,
        bucket: bucketData.stonetypefullname +
          " | " +
          bucketData.shape +
          " | " +
          bucketData.size +
          " | " +
          bucketData.color +
          " | " +
          bucketData.clarity,
        qty: bucketData.qty,
        avgprice: bucketData.avgprice,
        piece: 0,
        discount1: 0,
        discount2: 0,
        discount3: 0,
        purchaseprice: bucketData.defaultsellprice,
        finalprice: 0
      }];
      setRows(row);
    }

    getAllCompanyData();

    UtilityProxy.getDate((response) => {
      if (response) {
        const parts = response.errorMessage.split("-");
        setFormattedDate(`${parts[2]}-${parts[1]}-${parts[0]}`);
        setDate(response.errorMessage);
      }
    });
  }, []);

  const getAllCompanyData = () => {
    TradingcompanyProxy.GetAllTradingcompany((response) => setAllCompanyData(response));
  };

  const calculateFinalPayableAmount = (tempTotalAmount) => {
    let tempCGST = 0;
    let tempSGST = 0;
    let tempIGST = 0;
    if (addGst) {
      if (customerState && customerState.toLowerCase() === tradingCompanyState.toLowerCase() && currency.toUpperCase() === "INR") {
        tempCGST = (parseFloat(tempTotalAmount) * CGSTPercent) / 100;
        tempSGST = (parseFloat(tempTotalAmount) * SGSTPercent) / 100;
        tempIGST = 0;
      } else if (customerState && customerState.toLowerCase() !== tradingCompanyState.toLowerCase() && currency.toUpperCase() === "INR") {
        tempCGST = 0;
        tempSGST = 0;
        tempIGST = (parseFloat(tempTotalAmount) * IGSTPercent) / 100;
      }
    }
    setCGSTValue(tempCGST.toFixed(2));
    setSGSTValue(tempSGST.toFixed(2));
    setIGSTValue(tempIGST.toFixed(2));
    setPayableAmount((parseFloat(tempTotalAmount) + tempCGST + tempSGST + tempIGST).toFixed(2));
  }

  useEffect(() => {
    if (currency && invoiceAmount && (shippingCost || shippingCost === 0) && exchangeRate) {
      setTotalAmount(((Number(invoiceAmount) + Number(shippingCost))).toFixed(2));
      calculateFinalPayableAmount(((Number(invoiceAmount) + Number(shippingCost))).toFixed(2));
    }
  }, [currency, invoiceAmount, shippingCost, exchangeRate, customerState, company, currency, addGst]);

  const setAllCompanyData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.name, state: data.state };
      optionsArray.push(option);
      return true;
    });

    setCompany((prevCompany) => !prevCompany && optionsArray.length > 0 ? optionsArray[0] : prevCompany);
    setTradingCompanyState((prevCompany) => !prevCompany && optionsArray.length > 0 ? optionsArray[0].state : prevCompany.state);
    setCompanyOptions(optionsArray);
  };

  const prepareStoneData = () => {
    let selectedStoneId = [];

    rows.map((iRow) => {
      let obj = {
        id: iRow.id ? (typeof iRow.id === "string" ? undefined : iRow.id) : undefined,
        proformaid: iRow.perfomaid ? iRow.perfomaid : undefined,
        bucketid: iRow.bucketid,
        sellqty: iRow.purchaseqty,
        piece: iRow.piece,
        price: parseFloat(iRow.purchaseprice),
        discount1: iRow.discount1,
        discount2: iRow.discount2,
        discount3: iRow.discount3,
        remarks: iRow.remarks,
      };
      selectedStoneId.push(obj);
      return true;
    });

    return selectedStoneId;
  };

  let prepareData = () => {
    return {
      proformaid: sourceData && sourceData.length > 0 ? sourceData[0].id : null,
      date: Utility.ConvertLocalTimeToUtc(date).slice(0, 11) + "00:00:00.000Z",
      customerid: Constants.loggedInUser.usertype === "C" ? Constants.loggedInUser.id : customerData.customer.value,
      brokerid: !brokerData.broker || brokerData.broker.value === -1 ? -1 : brokerData.broker.value,
      userid: Constants.loggedInUser.id,
      tradingcompanyid: company.value,
      ...exportData,
      export: type.value === "local" ? false : true,
      exchangerate: parseFloat(exchangeRate),
      exchangecurrency: currency,
      shippingcost: parseFloat(shippingCost),
      finalpayableamount: parseFloat(payableAmount),
      remarks: remark,
      buckets: prepareStoneData(),
      memoid: memoId ? memoId.filter((value, index, array) => array.indexOf(value) === index) : undefined,
      days: invoiceDays ? invoiceDays : 0,
      cgstpercent: customerState && customerState.toLowerCase() === tradingCompanyState.toLowerCase() && currency.toUpperCase() === "INR" && addGst ? CGSTPercent : 0,
      sgstpercent: customerState && customerState.toLowerCase() === tradingCompanyState.toLowerCase() && currency.toUpperCase() === "INR" && addGst ? SGSTPercent : 0,
      igstpercent: customerState && customerState.toLowerCase() !== tradingCompanyState.toLowerCase() && currency.toUpperCase() === "INR" && addGst ? IGSTPercent : 0,
      totalamount: totalAmount,
      isgst: addGst,
    };
  };

  const saveInvoice = () => {
    if (exchangeRate > 1) {
      setDisableAllButtons(true);
      let data = prepareData();

      if (handleInvoice) {
        if (handleValidation) {
          if (handleValidation(data)) {
            handleInvoice(data);
          } else {
            setShowSnackbar(true);
            setSnackbarMessage("Validation Error");
            setSnackbarVariant("error");
          }
        } else {
          handleInvoice(data);
        }
      }
    } else {
      setShowSnackbar(true);
      setSnackbarVariant("warning");
      setSnackbarMessage("Please give appropriate exchange rate and try again later");
    }
  };

  const saveProforma = () => {
    if (exchangeRate > 1) {
      setDisableAllButtons(true);
      let data = prepareData();

      if (handleProforma) {
        if (handleValidation) {
          if (handleValidation(data)) {
            handleProforma(data);
          } else {
            setShowSnackbar(true);
            setSnackbarMessage("Validation Error");
            setSnackbarVariant("error");
          }
        } else {
          handleProforma(data);
        }
      }
    } else {
      setShowSnackbar(true);
      setSnackbarVariant("warning");
      setSnackbarMessage("Please give appropriate exchange rate and try again later");
    }
  };

  useEffect(() => {
    if (customerData.customer && customerData.customer.value &&
      customerData.customer.value !== -1 && flag) {
      getCustomerBrokers(customerData.customer.value);
      isUserStatePresent(customerData.customer.value);
    }
  }, [customerData]);

  const isUserStatePresent = (customerid) => {
    UserProfileProxy.isUserStatePresent(customerid, (response) => {
      if (response.status === "Success") {
        setCustomerStatePresent(false);
        setCustomerState(response.errorMessage);
      } else {
        setShowSnackbar(true);
        setSnackbarVariant("error");
        setSnackbarMessage("Customer state is not present in customer profile. Please update the customer profile and try again later");
        setCustomerStatePresent(true);
        setCustomerState("");
      }
    });
  }

  const getCustomerBrokers = (customerid) => {
    BrokerProxy.getCustomersBrokerMini(customerid, (response) => {
      if (response.length > 0) {
        let optionsArray = [];
        response.map(iData => optionsArray.push({ value: iData.brokerid, label: iData.brokerid + " | " + iData.companyname }));
        setBrokerData({ broker: !sourceData || sourceData.length === 0 ? optionsArray[0] : brokerData.broker, brokerOptions: optionsArray })
      } else {
        setBrokerData({ broker: !sourceData || sourceData.length === 0 ? { value: -1, label: " - " } : brokerData.broker, brokerOptions: [] });
      }
    });

    if (!sourceData || sourceData.length === 0) {
      MixBucketProxy.GetLatestMixProformaDetail(customerid, (response) => {
        if (response) {
          if (response.brokerCustomer.brokerid === -1) {
            setBrokerData({ ...brokerData, broker: { value: -1, label: " - " } })
          } else {
            setBrokerData({ ...brokerData, broker: { value: response.brokerCustomer.brokerid, label: response.brokerCustomer.brokerid + " | " + response.brokerCustomer.companyname } })
          }
        }
      });
    }
  }

  const handleDiscount = (e) => {
    setTotalDiscount(e.target.value);
    let newList = [];
    let totalInvoice = 0;
    rows.map((row) => {
      let actualPrice = row.purchaseprice * row.purchaseqty;
      totalInvoice += Number(
        actualPrice * ((100 + Number(e.target.value)) / 100)
      );
      let listOp = {
        ...row,
        discount: Number(e.target.value),
      };
      newList.push(listOp);
      return newList;
    });
    setRows(newList);
    setInvoiceAmount(totalInvoice.toFixed(2));
    setNewInvoiceAmount(totalInvoice.toFixed(2));
    setTotalAmount(((Number(totalInvoice) + Number(shippingCost))).toFixed(2));
    calculateFinalPayableAmount(((Number(totalInvoice) + Number(shippingCost))).toFixed(2));
  };

  const handleInovice = (e) => {
    if ((e.key === 'Enter' || e.type === 'blur') && e.target.value !== newInvoiceAmount) {
      let lDiscount = Number((100 - (Number(e.target.value) * 100) / actualAmount) * -1);
      setTotalDiscount(lDiscount.toFixed(2));
      setTotalAmount(((Number(e.target.value) + Number(shippingCost))).toFixed(2));
      calculateFinalPayableAmount(((Number(e.target.value) + Number(shippingCost))).toFixed(2));
      let newList = [];
      let lInvoiceAmount = 0;
      let lastIndex = rows.length - 1;
      rows.map((row, index) => {
        let tdiscount = parseFloat((e.target.value / newInvoiceAmount));
        let iDiscountPrice = parseFloat((tdiscount * row.finalprice).toFixed(2));

        if (index === lastIndex) {
          iDiscountPrice = parseFloat((invoiceAmount - lInvoiceAmount).toFixed(2));
        }

        let listOp = {
          ...row,
          discount1: (Number((100 - (Number(iDiscountPrice) * 100) / (Number(row.purchaseqty) * Number(row.purchaseprice))) * -1)).toFixed(2),
          discount2: 0,
          discount3: 0,
          finalprice: iDiscountPrice.toFixed(2),
        };
        newList.push(listOp);
        lInvoiceAmount += Number(listOp.finalprice);
        return newList;
      });
      setRows(newList);
      setInvoiceAmount(e.target.value);
      setNewInvoiceAmount(e.target.value);
    }
  };

  const handleShippingCost = (val) => {
    setShippingCost(val);
    setTotalAmount((Number(invoiceAmount) + Number(val)).toFixed(2));
    calculateFinalPayableAmount((Number(invoiceAmount) + Number(val)).toFixed(2));
  };

  const handleExchangeRate = (e) => {
    setExchangeRate(e.target.value);
    setTotalAmount((Number(invoiceAmount) + Number(shippingCost)).toFixed(2));
    calculateFinalPayableAmount((Number(invoiceAmount) + Number(shippingCost)).toFixed(2));
  };

  const handleProformaDetailChange = (event, value) => {
    setProformaPaginatedValueId(sourceData[value - 1].proformaid);
    prepareProformaDetailData(sourceData[value - 1]);
    setPage(value);
  };

  const handleBucketDetailModal = (params) => {
    setBucketId(params.value);
    setShowBucketDetailModal(true)
  };

  const addNewRow = () => {
    let newRow = {
      id: rows.length + 1,
      bucketid: bucket.value,
      bucket: bucket.value,
      qty: 0,
      avgprice: 0,
      purchaseqty: 0,
      purchaseprice: 0,
      discount1: 0,
      discount2: 0,
      discount3: 0,
      piece: 0,
      finalprice: 0,
      remarks: "",
      actions: "",
    };
    setRows((prevRows) => [...prevRows, newRow]);
  }

  const getDropDownComponent = (options, listData, openDropdown, setOpenDropdown, setRows) => {
    return getDropdownEditComponent(options, listData, openDropdown, setOpenDropdown, setRows);
  }

  const columnName = [
    {
      field: "bucketid",
      headerName: "BUCKETID",
      width: 90,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (Utility.NeedToShowBucketDetailModal()) ?
        <Button
          sx={{
            textDecorationLine: "underline",
            color: 'black'
          }}
          onClick={() => { if (params.value) handleBucketDetailModal(params) }}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "bucket",
      headerName: "BUCKET",
      width: 310,
      editable: !bucketDisabled,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => bucketDisabled ? params.value : (
        <Box style={{ display: 'flex', alignItems: 'center', width: "21rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      renderEditCell: bucketDisabled ? null : getDropDownComponent(bucketOption, listData, openDropdown, setOpenDropdown, setRows),
      cellClassName: bucketDisabled ? null : 'lavenderCell',
    },
    {
      field: "qty",
      headerName: "CURRENT QTY (CTS)",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "avgprice",
      headerName: "AVG PRICE (USD $)",
      width: 140,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => `$ ${params.value}`
    },
    {
      field: "purchaseqty",
      headerName: "SELL QTY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 80,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "purchaseprice",
      headerName: `SELL PRICE ${currency === "USD" ? "(USD $)" : "(INR ₹)"}`,
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      width: 150,
      editable: true,
      // renderCell: (params) => `${currency === "USD" ? "$" : "₹"} ${params.value}`,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "discount1",
      headerName: "DIS 1",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value === "" ? 0 : params.value,
      width: 80,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "discount2",
      headerName: "DIS 2",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value === "" ? 0 : params.value,
      width: 80,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "discount3",
      headerName: "DIS 3",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value === "" ? 0 : params.value,
      width: 80,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "piece",
      headerName: "PIECES",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 70,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "finalprice",
      headerName: `FINAL PRICE ${currency === "USD" ? "(USD $)" : "(INR ₹)"}`,
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => `${currency === "USD" ? "$" : "₹"} ${params.value}`,
    },
    {
      field: "remarks",
      headerName: "REMARKS",
      headerAlign: "center",
      align: "center",
      width: bucketData ? 305 : 255,
      editable: true,
      renderCell: (params) => (
        <Box style={{ display: 'flex', alignItems: 'center', width: "17rem" }}>
          <span style={{ width: "90%", textAlign: "center" }}>{params.value}</span>
          {<EditIcon style={{ marginLeft: 10, fontSize: '1rem' }} />}
        </Box>
      ),
      cellClassName: 'lavenderCell',
    },
    {
      field: "actions",
      headerName: "",
      width: 50,
      cellClassName: "actions",
      headerAlign: "center",
      align: "center",
      renderCell: (params) =>
        <DeleteForeverIcon
          style={{ cursor: "pointer", fontSize: "1.5rem" }}
          color={"error"}
          onClick={() => setRows(prevRows => prevRows.filter((row) => row.id !== params.id))}
        />
    },
  ];

  const columns = columnName.filter(iColumn => {
    if (iColumn.field === "qty" && !qtyPermission) return false;
    if (iColumn.field === "avgprice" && !avgPricePermission) return false;
    if (iColumn.field === "actions" && (notPermitted || bucketData)) return false;
    return true;
  });

  const setSnackbar = (showSnackbar, snackbarMessage, snackbarVariant) => {
    setShowSnackbar(showSnackbar);
    setSnackbarMessage(snackbarMessage);
    setSnackbarVariant(snackbarVariant);
  }

  const processRowUpdate = (newRow, oldRow) => {
    const changedFeilds = Utility.getChangedFields(newRow, oldRow);
    if (changedFeilds.length > 0) {
      let { field } = changedFeilds[0];
      if (field !== "bucket") {
        if (!newRow.bucketid) {
          setSnackbar(true, "Please select bucket.", "error");
        } else {
          if (field === "purchaseqty" && (parseFloat(newRow.purchaseqty) <= 0 || parseFloat(newRow.purchaseqty) >= parseFloat(newRow.qty))) {
            setSnackbar(true, "SELL QTY should be greater than 0 and less than CURRENT QTY.", "error");
          } else if (field === "purchaseprice" && parseFloat(newRow.purchaseprice) <= 0) {
            setSnackbar(true, "SELL PRICE should be greater than 0", "error");
          } else {
            let actualPrice = Number(newRow.purchaseprice) * Number(newRow.purchaseqty);
            let priceAfterDiscount1 = discountCalculator(actualPrice, newRow.discount1);
            let priceAfterDiscount2 = discountCalculator(priceAfterDiscount1, newRow.discount2);
            let priceAfterDiscount3 = discountCalculator(priceAfterDiscount2, newRow.discount3);
            const updatedRow = {
              ...newRow,
              finalprice: priceAfterDiscount3,
            };

            let allRows = rows.map((row) => (row.id === newRow.id ? updatedRow : row));
            let lActualAmount = 0;
            let lInvoiceAmount = allRows.reduce((acc, cum) => (acc += parseFloat(cum.finalprice)), 0);
            let lTotalCarat = allRows.reduce((acc, cum) => (acc += parseFloat(cum.purchaseqty)), 0);
            allRows.map((row) => (lActualAmount += Number(row.purchaseqty) * Number(row.purchaseprice)));

            setRows(allRows);
            setInvoiceAmount(lInvoiceAmount);
            setNewInvoiceAmount(lInvoiceAmount);
            setTotalCarat(lTotalCarat.toFixed(2));
            setActualAmount(lActualAmount);
            setTotalDiscount(Number((100 - (lInvoiceAmount * 100) / lActualAmount) * -1).toFixed(2));
            setDisableSell(false);

            return updatedRow;
          }
        }
      }
    }
    return oldRow;
  };

  const handleProcessRowUpdateError = (error) => {
    // console.error(error);
  };

  const applyValueToAllFields = () => {
    if (rows.length > 0) {
      const updatedRows = rows.map((row) => ({ ...row }));
      let rowsToUpdate = updatedRows;

      rowsToUpdate.forEach(filteredRow => {
        const matchingRowIndex = updatedRows.findIndex(row => row.id === filteredRow.id);

        if (matchingRowIndex !== -1) {
          let updatedRow = { ...updatedRows[matchingRowIndex] };
          let actualPrice = Number(updatedRow.purchaseprice) * Number(updatedRow.purchaseqty);
          if (applyToAll === "discount1") {
            updatedRow.discount1 = parseFloat(applyValue);
          }
          else if (applyToAll === "discount2") {
            updatedRow.discount2 = parseFloat(applyValue);
          }
          else if (applyToAll === "discount3") {
            updatedRow.discount3 = parseFloat(applyValue);
          }
          let priceAfterDiscount1 = discountCalculator(actualPrice, updatedRow.discount1);
          let priceAfterDiscount2 = discountCalculator(priceAfterDiscount1, updatedRow.discount2);
          let priceAfterDiscount3 = discountCalculator(priceAfterDiscount2, updatedRow.discount3);
          updatedRow.finalprice = priceAfterDiscount3;

          updatedRows[matchingRowIndex] = updatedRow;
        }
      });
      setRows(updatedRows);
    }
  }

  useEffect(() => {
    if (rows.length === 0) {
      setInvoiceAmount(0);
      setNewInvoiceAmount(0);
      setTotalCarat(0);
      setActualAmount(0);
      setTotalDiscount(0);
      setTotalAmount(0);
      setPayableAmount(0);
      setCGSTValue(0);
      setSGSTValue(0);
      setIGSTValue(0);
      setShippingCost(0);
      setTotalCarat(0);
    } else {
      // Aggregate totals
      let lActualAmount = 0;
      let lInvoiceAmount = 0;
      let lTotalCarat = 0;

      rows.forEach((row) => {
        lActualAmount += Number(row.purchaseprice) * Number(row.purchaseqty);
        lInvoiceAmount += parseFloat(row.finalprice);
        lTotalCarat += parseFloat(row.purchaseqty);
      });

      // Update state
      setInvoiceAmount(lInvoiceAmount);
      setNewInvoiceAmount(lInvoiceAmount);
      setTotalCarat(lTotalCarat.toFixed(2));
      setActualAmount(lActualAmount);

      // Calculate total discount %
      const totalDiscountPercentage = Number((100 - (lInvoiceAmount * 100) / lActualAmount) * -1).toFixed(2);
      setTotalDiscount(totalDiscountPercentage);
    }
  }, [rows]);

  return (
    <Box>

      <CommonSnackbar
        show={showSnackbar}
        message={snackbarMessage}
        variant={snackbarVariant}
        autoHide={Constants.SnackBarCloseTimer}
        handleClose={() => setShowSnackbar(false)}
        title={snackbarVariant === "success" ? "Success" : snackbarVariant === "error" ? "Error" : "Warning"}
      />

      {showBucketDetailModal ? (
        <BucketDetailModal
          show={showBucketDetailModal}
          bucketId={bucketId}
          handleClose={() => setShowBucketDetailModal(false)}
        />
      ) : null}

      {showUserDetailModal && (
        <Box>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(1px)",
              zIndex: 1299,
            }}
          />
          <UserDetailModal
            show={true}
            handleClose={() => setShowUserDetailModal(false)}
            handleSelect={(selectedOption) => {
              const selectedData = (userDetailContext === "C" ? customerData.customerOptions : brokerData.brokerOptions)
                .filter(opt => selectedOption.includes(opt.value));
              if (userDetailContext === "C") {
                setCustomerData({
                  ...customerData,
                  customer: selectedData[0],
                });
              } else if (userDetailContext === "B") {
                setBrokerData({
                  ...brokerData,
                  broker: selectedData[0],
                });
              }
              setShowUserDetailModal(false);
            }}
            userids={(userDetailContext === "C" ? customerData.customerOptions : brokerData.brokerOptions)
              .map(opt => opt.value)}
            selectedIds={userDetailContext === "C" ? (customerData.customer.value ? [customerData.customer.value] : []) : (brokerData.broker.value ? [brokerData.broker.value] : [])}
            usertype={userDetailContext}
            loading={showUserDetailModal}
            isMulti={false}
          />
        </Box>
      )}

      <Modal backdrop="static" show={show} onHide={setShow} dialogClassName="bhb" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;
            {proformaButton ? "Sell Buckets" : "Convert Proforma to Invoice"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box>
            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 1fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap="15px"
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "15px", alignItems: "center" }}>
                  <Typography sx={{ width: "30%", margin: 0 }}>
                    Customer Company
                  </Typography>
                  {Constants.loggedInUser.usertype !== "C" ? (
                    <div style={{ width: "70%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          width: "97%",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Box style={{ width: "100%" }}>
                            <Select menuPlacement="auto"
                              blurInputOnSelect={false}
                              className="basic-single"
                              classNamePrefix="select"
                              value={customerData.customer}
                              isSearchable={true}
                              name="Customer"
                              menuPortalTarget={document.body}
                              styles={Constants.Styles}
                              options={customerData.customerOptions}
                              onChange={(selectedOption) => {
                                setCustomerData({
                                  ...customerData,
                                  customer: selectedOption,
                                });
                              }}
                              isDisabled={!proformaButton}
                            />
                          </Box>
                        </Box>
                        <Tooltip title="View More Data">
                          <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                            <OpenInNewIcon
                              style={{ fontSize: "20px", marginBottom: "3px" }}
                              onClick={() => {
                                setShowUserDetailModal(true);
                                setUserDetailContext("C");
                              }}
                              color="action"
                            />
                          </span>
                        </Tooltip>
                      </Box>
                    </div>
                  ) : (
                    <Typography fontWeight={Constants.defaultFontWeightBold}>
                      {Constants.loggedInUser.id + " | " + Constants.loggedInUser.companyname}
                    </Typography>
                  )}
                </Box>

                {Constants.loggedInUser.usertype !== "C" ? (
                  <Box sx={{ display: "flex", width: "100%", gap: "15px", alignItems: "center", marginTop: "8px" }}>
                    <Typography sx={{ width: "30%", margin: 0 }}>
                      Broker Company
                    </Typography>
                    <div style={{ width: "70%" }}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          width: "97%"
                        }}
                      >
                        <Box sx={{ flexGrow: 1 }}>
                          <Box style={{ width: "100%" }}>
                            <Select menuPlacement="auto"
                              blurInputOnSelect={false}
                              menuPortalTarget={document.body}
                              styles={{
                                ...Constants.Styles,
                                control: (base) => ({
                                  ...base,
                                  // width: '20.5rem',
                                  minHeight: "38px"
                                }),
                              }}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                              options={brokerData.brokerOptions}
                              value={!brokerData.broker || brokerData.broker === -1 ? { value: -1, label: " - " } : { value: brokerData.broker.brokerid, label: brokerData.broker.label }}
                              isClearable
                              onChange={(e) => setBrokerData({ ...brokerData, broker: e })}
                              isDisabled={!customerData.customer || !proformaButton}
                            />
                          </Box>
                        </Box>
                        <Tooltip title="View More Data">
                          <span style={{ cursor: "pointer", marginLeft: "8px" }}>
                            <OpenInNewIcon
                              style={{ fontSize: "20px", marginBottom: "3px" }}
                              onClick={() => {
                                setUserDetailContext("B");
                                setShowUserDetailModal(true);
                              }}
                              color="action"
                            />
                          </span>
                        </Tooltip>
                      </Box>
                    </div>
                  </Box>
                ) : null}

                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  mt: "8px",
                  gap: "15px"
                }}>
                  <Typography sx={{ width: "30%" }}>User Company</Typography>
                  <Typography sx={{ width: "60%", fontWeight: "bold" }}>{lUser}</Typography>
                </Box>
              </Box>
              <Box sx={{ paddingLeft: "16px" }}>
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}>
                  <Box sx={{ width: "35%" }}>
                    <Typography>Trading Company</Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      value={company}
                      isSearchable={true}
                      name="Trading Company"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={companyOptions}
                      onChange={(selectedOption) => {
                        setCompany(selectedOption);
                        setTradingCompanyState(selectedOption.state);
                      }}
                      isDisabled={notPermitted}
                    />
                  </Box>
                </Box>
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  mt: 1
                }}>
                  <Box sx={{ width: "35%" }}>
                    <Typography>Type</Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      options={typeOptions}
                      value={type}
                      onChange={(e) => setType(e)}
                      isDisabled={notPermitted}
                    />
                  </Box>
                </Box>
              </Box>
              <Box display={"flex"} gap="15px" flexDirection={"column"} marginLeft={"2rem"}>
                <Box
                  display={"flex"}
                  gap="15px"
                  alignItems={"center"}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      height: "0.5rem",
                    },
                    "& .MuiTextField-root": {
                      marginTop: 0,
                      marginBottom: 0
                    }
                  }}
                >
                  <Typography m={0}>Date</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TextField
                      margin="normal"
                      fullWidth
                      label="Date"
                      disabled
                      value={formattedDate}
                    />
                  </LocalizationProvider>
                </Box>
                {sourceData !== undefined && sourceData.length > 1 ? (
                  <Stack>
                    <Typography textAlign={"center"}>
                      Proforma: {proformaPaginatedValueId}
                    </Typography>
                    <Pagination
                      count={sourceData.length}
                      page={page}
                      onChange={handleProformaDetailChange}
                      sx={{ alignSelf: "center" }}
                      variant="outlined"
                      color="primary"
                      size="small"
                      shape="rounded"
                    />
                  </Stack>
                ) : null}
              </Box>
            </Box>

            {type.value === "export" ? (
              <ExportComponent
                countryOfOrigin={countryOfOrigin}
                insurredBy={insurredBy}
                portOfLoading={portOfLoading}
                countryOfFinalDestination={countryOfFinalDestination}
                shippedBy={shippedBy}
                portOfDischarge={portOfDischarge}
                terms={terms}
                finalDestination={finalDestination}
                bankThrough={bankThrough}
                exportComponentData={exportComponentData}
                notPermitted={notPermitted}
              />
            ) : null}

            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                marginTop: "8px",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                height: '40.7vh',
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
              }}
            >
              <StyledDataGrid
                disableRowSelectionOnClick={true}
                localeText={{ noRowsLabel: "No Record Found" }}
                sx={{ fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight }}
                slots={{ toolbar: GridToolbar }}
                rows={rows}
                density="compact"
                columns={columns}
                getRowId={(row) => row.id}
                // loading={stockLoader}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns id, the other columns will remain visible
                    },
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: {
                      debounceMs: 500,
                    },
                  },
                }}
                experimentalFeatures={{ newEditingApi: true }}
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}
                apiRef={apiRef}
                onCellClick={handleCellClick}
                editMode="cell"
              />

              <Box sx={{
                position: "absolute",
                top: "5px",
                left: "29rem",
                width: "60rem",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <LoadingButton
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => addNewRow()}
                  sx={{ height: "31px" }}
                  disabled={bucketData}
                >
                  Add New Row
                </LoadingButton>

                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  "& .MuiInputBase-input": {
                    padding: "4px 8px !important",
                    width: "6.8rem"
                  },
                  "& .MuiInputLabel-root[data-shrink='false']": {
                    top: "-6px !important",
                    color: "rgba(0, 0, 0, 0.4) !important",
                  },
                  "& .MuiTextField-root": {
                    marginTop: 0,
                    marginBottom: 0
                  }
                }}>
                  <FormControl sx={{ width: "7.7rem" }}>
                    <MuiSelect
                      sx={{
                        "& .MuiOutlinedInput-input": {
                          padding: "6px 12px 7px",
                          lineHeight: "1.5",
                        },
                      }}
                      labelId="select-label"
                      value={applyToAll}
                      onChange={(event) => setApplyToAll(event.target.value)}
                    >
                      <MenuItem value="discount1">Discount 1</MenuItem>
                      <MenuItem value="discount2">Discount 2</MenuItem>
                      <MenuItem value="discount3">Discount 3</MenuItem>
                    </MuiSelect>
                  </FormControl>
                  <TextField
                    margin="normal"
                    placeholder="Enter Discount"
                    value={applyValue}
                    onChange={(e) => setApplyValue(e.target.value)}
                  />
                  <LoadingButton
                    variant="contained"
                    onClick={applyValueToAllFields}
                    type="submit"
                    color="success"
                    loadingPosition="start"
                    startIcon={<CheckCircleIcon />}
                    sx={{ width: "105px", height: "31px" }}
                    disabled={!applyValue}
                  >
                    Apply
                  </LoadingButton>
                </Box>
              </Box>

            </Box>

            <Box
              display={"grid"}
              gridTemplateColumns={"1fr 1fr 1fr 1fr"}
              width={"100%"}
              height={"100%"}
              gap={"15px"}
              sx={{
                "& .MuiInputBase-input": {
                  padding: "10px 14px !important"
                },
                "& .MuiInputLabel-root[data-shrink='false']": {
                  top: "-6px !important",
                  color: "rgba(0, 0, 0, 0.4) !important",
                },
                "& .MuiTextField-root": {
                  marginBottom: 0
                }
              }}
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Pieces"
                    disabled
                    value={rows.reduce((acc, cumm) => (acc += cumm.piece), 0)}
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Carats"
                    disabled
                    value={totalCarat}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label={`CGST (${customerState && tradingCompanyState && customerState.toLowerCase() === tradingCompanyState.toLowerCase() && currency && currency.toUpperCase() === "INR" && addGst ? CGSTPercent : "0.00"}%)`}
                    value={CGSTValue}
                    disabled
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Shipping Cost"
                    placeholder="Enter Shipping Cost"
                    value={shippingCost}
                    onChange={(e) => {
                      let updatedValue = isNaN(e.target.value) ? 0 : e.target.value;
                      updatedValue = updatedValue < 0 ? 0 : updatedValue;
                      handleShippingCost(updatedValue)
                    }}
                    disabled={notPermitted}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Discount"
                    placeholder="Enter Discount"
                    value={totalDiscount}
                    onChange={(e) => handleDiscount(e)}
                    disabled
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label={`SGST (${customerState && tradingCompanyState && customerState.toLowerCase() === tradingCompanyState.toLowerCase() && currency && currency.toUpperCase() === "INR" && addGst ? SGSTPercent : "0.00"}%)`}
                    value={SGSTValue}
                    disabled
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label={`IGST (${customerState && tradingCompanyState && customerState.toLowerCase() !== tradingCompanyState.toLowerCase() && currency && currency.toUpperCase() === "INR" && addGst ? IGSTPercent : "0.00"}%)`}
                    value={IGSTValue}
                    disabled
                  />
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "10px 0px !important"
                      }
                    }}
                    label={`Invoice Amount ${currency === "USD" ? "(USD)" : "(INR)"}`}
                    placeholder="Enter invoice amount"
                    value={invoiceAmount}
                    onChange={(e) => setInvoiceAmount(e.target.value)}
                    onKeyDown={handleInovice}
                    onBlur={handleInovice}
                    disabled={notPermitted}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">{`${currency === "USD" ? "$" : "₹"}`}</InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "10px 0px !important"
                      }
                    }}
                    label={`Total Amount ${currency === "USD" ? "(USD)" : "(INR)"}`}
                    value={totalAmount}
                    disabled
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">{`${currency === "USD" ? "$" : "₹"}`}</InputAdornment>
                      ),
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                  <TextField
                    label="Payable Amount (USD)"
                    id="outlined-start-adornment"
                    margin="normal"
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "10px 0px !important"
                      }
                    }}
                    disabled
                    fullWidth
                    value={currency === "USD" ? payableAmount : (payableAmount / exchangeRate).toFixed(2)}
                    InputProps={{
                      startAdornment: (<InputAdornment position="start">$</InputAdornment>),
                    }}
                  />
                  {currency === "INR" && (
                    <TextField
                      label="Payable Amount (INR)"
                      id="outlined-start-adornment"
                      margin="normal"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "10px 0px !important"
                        }
                      }}
                      disabled
                      fullWidth
                      value={payableAmount}
                      InputProps={{
                        startAdornment: (<InputAdornment position="start">₹</InputAdornment>),
                      }}
                    />
                  )}
                </Box>
              </Box>
              <Box display={"flex"} flexDirection={"column"}>
                <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Exchange Rate"
                    placeholder="Enter Exchange Rate"
                    value={exchangeRate}
                    onChange={(e) => handleExchangeRate(e)}
                    onBlur={() => {
                      if (!exchangeRate || Number(exchangeRate) === 0) {
                        setExchangeRate(1);
                      }
                    }}
                    disabled={notPermitted}
                  />

                  <TextField
                    margin="normal"
                    type="number"
                    fullWidth
                    label="Days"
                    placeholder="Enter Days"
                    value={invoiceDays}
                    onKeyDown={(e) => {
                      if (e.key === "+" || e.key === "-") {
                        e.preventDefault(); // Prevent typing + or -
                      }
                    }}
                    onChange={(e) => setInvoiceDays(e.target.value)}
                    disabled={notPermitted}
                  />
                </Box>
                <Box display={"flex"} flexDirection={"column"}>
                  <FormControl sx={{ mt: 0, display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                    <FormLabel sx={{ mr: 2, mb: 0 }}>Exchange Currency</FormLabel>
                    <RadioGroup
                      row
                      name="Exchange Currency"
                      value={currency}
                      onChange={(e) => {
                        setCurrency(e.target.value);
                        setExchangeRate(1);
                      }}
                    >
                      <FormControlLabel
                        value="USD"
                        control={<Radio />}
                        label="USD"
                        disabled={notPermitted}
                        sx={{ marginBottom: 0 }}
                      />
                      <FormControlLabel
                        value="INR"
                        control={<Radio />}
                        label="INR"
                        disabled={notPermitted}
                        sx={{ marginBottom: 0 }}
                      />
                    </RadioGroup>
                  </FormControl>

                  <FormControl
                    sx={{
                      marginLeft: "4rem",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        marginBottom: "0px",
                        alignItems: "center",
                        width: "160px",
                      }}
                    >
                      COD
                    </Typography>
                    <FormGroup>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography
                          sx={{
                            color: currency === "USD" ? "grey" : "inherit", // Light grey when disabled
                          }}
                        >
                          YES
                        </Typography>
                        <AntSwitch
                          checked={addGst}
                          onChange={() => setAddGst(!addGst)}
                          inputProps={{ 'aria-label': 'ant design' }}
                          disabled={currency === "USD"} // Disable based on condition
                        />
                        <Typography
                          sx={{
                            color: currency === "USD" ? "grey" : "inherit", // Light grey when disabled
                          }}
                        >
                          NO
                        </Typography>
                      </Stack>
                    </FormGroup>
                  </FormControl>

                </Box>
              </Box>
            </Box>

            <Box sx={{
              display: "flex", width: "100%",
              "& .MuiInputLabel-root[data-shrink='false']": {
                top: "-6px !important",
                color: "rgba(0, 0, 0, 0.4) !important",
              },
              "& .MuiTextField-root": {
                marginTop: 1,
                marginBottom: 0
              },
              "& .MuiOutlinedInput-input": {
                padding: "10px 14px",
              },
            }}>
              <TextField
                margin="normal"
                fullWidth
                rows={1}
                label="Remark"
                placeholder="Enter Remark"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disabled={notPermitted}
              />
            </Box>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          {(proformaButton && Utility.isAddAllowed(proforma_Permission)) || (!proformaButton && Utility.isUpdateAllowed(proforma_Permission)) ? (
            <LoadingButton
              variant="contained"
              onClick={saveProforma}
              loading={loadingProformaButton}
              loadingPosition="start"
              type="Submit"
              startIcon={<FaFileInvoice />}
              disabled={disableSell || !customerData.customer || customerStatePresent || rows.length === 0 || disableAllButtons}
              sx={{ mr: 2 }}
            >
              {proformaButton && Utility.isAddAllowed(proforma_Permission) ? "Proforma" : "Update"}
            </LoadingButton>
          ) : null}

          {(proformaButton && Utility.isAddAllowed(invoice_Permission)) || (!proformaButton && Utility.isUpdateAllowed(invoice_Permission)) ? (
            <LoadingButton
              variant="contained"
              onClick={saveInvoice}
              type="Submit"
              loading={loading}
              loadingPosition="start"
              color="success"
              startIcon={<FaFileInvoiceDollar />}
              disabled={disableSell || !customerData.customer || customerStatePresent || rows.length === 0 || disableAllButtons}
              sx={{ mr: 2 }}
            >
              Invoice
            </LoadingButton>
          ) : null}

          <Button
            variant="contained"
            color="error"
            onClick={setShow}
            sx={{ mr: 0.5 }}
            disabled={disableAllButtons}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </Box >
  );
};

export default AddSaleModal;